import { render } from "./SelectorAgeView.vue?vue&type=template&id=04af3b5a"
import script from "./SelectorAgeView.vue?vue&type=script&lang=js"
export * from "./SelectorAgeView.vue?vue&type=script&lang=js"

import "./SelectorAgeView.vue?vue&type=style&index=0&id=04af3b5a&lang=css"

import exportComponent from "C:\\src\\Inmersys\\tres-prima\\mundo-zac-webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__